import { GD } from "src/GD";
import { BanksService } from "./BanksService";

export class UsersService {
	constructor() {
		GD.REQ_USERS.listener = async req => this.getUsers(req);
		GD.REQ_INVITE_USER.listener = async req => this.inviteUser(req);
		GD.REQ_INVITE_GET.listener = async req => this.inviteGet(req);
		GD.REQ_INVITES.listener = async req => this.invitesGet(req);
	}

	async invitesGet(_req: {}): Promise<IAPIResponse<IInvite[]>> {
		const getUsetsReq = await GD.REQ_API.request({
			method: "users/invite/list",
			data: {},
		});

		return getUsetsReq;
	}

	async inviteGet(req: { code: string }): Promise<IAPIResponse<IInviteUser>> {
		const getUsetsReq = await GD.REQ_API.request({
			method: "users/invite/get",
			data: {
				token: req.code,
			},
		});

		return getUsetsReq;
	}

	async inviteUser(req: { email: string; role_id: number }): Promise<IAPIResponse<boolean>> {
		const getUsetsReq = await GD.REQ_API.request({
			method: "users/invite/send",
			data: {
				email: req.email,
				role_id: req.role_id,
			},
		});

		return getUsetsReq;
	}

	async getUsers(req: {
		excludeCurrentProject?: boolean;
		search?: string;
		clientID?: number;
		roles?: number[];
		excludedRoles?: number[];
		include_deleted?: boolean;
	}): Promise<IAPIResponse<IUser[]>> {
		//!TODO: cache?;

		const getUsetsReq = await GD.REQ_API.request({
			method: "users/list",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				exclude_current_project: req.excludeCurrentProject,
				search: req.search,
				client_id: req.clientID,
				roles: req.roles,
				excluded_roles: req.excludedRoles,
				include_deleted: req.include_deleted,
			},
		});

		return getUsetsReq;
	}
}
